// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalActions_wrapper__tvKvR","actions":"ModalActions_actions__-r6q1","action":"ModalActions_action__O7FOw"};